import client from './client';

// Physical resources are team-scoped: every call carries the active `team` id,
// passed as a query param on reads and in the body on writes (the backend's
// resolveScheduleTeam reads `req.query.team || req.body.team`).
export const physicalResourcesApi = {
  async list(params = {}) {
    const { data } = await client.get('/api/physical-resources', { params });
    return data;
  },

  async get(id, team) {
    const { data } = await client.get(`/api/physical-resources/${id}`, {
      params: { team },
    });
    return data;
  },

  async create(resourceData) {
    const { data } = await client.post('/api/physical-resources', resourceData);
    return data;
  },

  async update(id, resourceData) {
    const { data } = await client.patch(`/api/physical-resources/${id}`, resourceData);
    return data;
  },

  async archive(id, team) {
    const { data } = await client.post(`/api/physical-resources/${id}/archive`, { team });
    return data;
  },
};
